import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation } from "swiper";
import banner from "../../../static/images/carsubs/user/banner.png";
import img1 from "../../../static/images/carsubs/user/user1.png";
import img2 from "../../../static/images/carsubs/user/user2.png";
import img3 from "../../../static/images/carsubs/user/user3.png";
import img4 from "../../../static/images/carsubs/user/user4.png";
import img5 from "../../../static/images/carsubs/user/user5.png";

const LIST_ITEM = [
	{ id: 1, img: img1 },
	{ id: 2, img: img2 },
	{ id: 3, img: img3 },
	{ id: 4, img: img4 },
	{ id: 5, img: img5 },
];

const Item = ({ item }) => (
	<div className="photo-item fix-img">
		<img loading="eager" src={item.img} />
	</div>
);

const Customer = () => {
	return (
		<div className="user-section">
			<div className="m-container">
				<div className="cus-banner" style={{backgroundImage: `url(${banner})`}}>
					<div className="cus-inner"> 
					<h2>Hình Ảnh Micar Và Khách&nbsp;Hàng</h2>
					<p>Với mong muốn thiết lập mối quan hệ lâu dài với Khách hàng, MICAR đảm bảo cung cấp dịch vụ Cho thuê xe dài hạn TẬN TÂM - UY TÍN - AN TOÀN, đem đến những trải nghiệm hài lòng, chất lượng với mức chi phí hợp lý.</p>
				<Swiper
					className="swiper-cus"
					slidesPerView={1}
					modules={[Navigation, Autoplay]}
					// pagination={{
					// 	el: ".pagi-cover",
					// 	clickable: true,
					// 	dynamicBullets: true,
					// }}
					navigation={{
						nextEl: '.cus-next',
						prevEl: '.cus-prev',
					}}
					autoplay={{
						delay: 3000,
						disableOnInteraction: false,
					}}
					grabCursor={true}
					centeredSlides={true}
					loop={true}
					breakpoints={{
						992: {
							slidesPerView: 1.8,
							spaceBetween: 24
						},
						768: {
							slidesPerView: 1,
							spaceBetween: 0
						}
					}}>
					{LIST_ITEM.map((item) => (
						<SwiperSlide key={item.id}>
							<Item item={item} />
						</SwiperSlide>
					))}
					
					{/* <div className="swiper-pagination pagi-cover" /> */}
					<div className="swiper-button-next cus-next"></div>
					<div className="swiper-button-prev cus-prev"></div>
				</Swiper>
				
			</div>
		</div>
		</div>
		</div>
	);
};

export default Customer;
// var swiperDestination3 = new Swiper('.swiper-cus', {
// 	slidesPerView: 1,
// 	spaceBetween: 0,
// 	threshold: 15,
// 	speed: 600,

// 	pagination: {
// 		el: ".pagi-cover" ,
// 		clickable: true,
// 		dynamicBullets: true,
// 	},
// 	navigation: {
// 		nextEl: ".swiper-button-next",
// 		prevEl: ".swiper-button-prev",
// 	},
// 	grabCursor: true,
// 	centeredSlides: true,
// 	loop: true,
// 	slidesOffsetBefore: 0,
// 	slidesOffsetAfter: 0,
// 	breakpoints: {
// 		992: {
// 			slidesPerView: 1.8,
// 			spaceBetween: 24
// 		},
// 		768: {
// 			slidesPerView: 1,
// 			spaceBetween: 0
// 		}
// 	}
// });

{/* <div className="user-section">
        <div className="m-container"> 
          <div className="cus-banner" style={{backgroundImage: 'url(images/carsubs/user/banner.png)'}}>
            <div className="cus-inner"> 
              <h2>Hình Ảnh Micar Và&nbsp;Khách&nbsp;Hàng </h2>
              <p>Lorem ipsum dolor sit amet consectetur. Duis donec facilisis nunc mauris ut. Tempus quis pellentesque sociis sagittis eu morbi. Phasellus metus tempus feugiat vulputate. Tempor sed velit accumsan nec amet magna vulputate senectus</p>
              <div className="swiper swiper-cus swiper-initialized swiper-horizontal swiper-pointer-events swiper-backface-hidden">
                <div className="swiper-wrapper" style={{cursor: 'grab', transitionDuration: '0ms', transform: 'translate3d(-1744.888889px, 0px, 0px)'}} id="swiper-wrapper-955704ad242109edb" aria-live="polite"><div className="swiper-slide swiper-slide-duplicate swiper-slide-duplicate-next" style={{width: '647.111111px', marginRight: '24px'}} role="group" aria-label="3 / 4" data-swiper-slide-index={2}> 
                    <div className="photo-item"><img src="images/carsubs/user/temp.png" alt="" /></div>
                  </div><div className="swiper-slide swiper-slide-duplicate" style={{width: '647.111111px', marginRight: '24px'}} role="group" aria-label="4 / 4" data-swiper-slide-index={3}> 
                    <div className="photo-item"><img src="images/carsubs/user/temp.png" alt="" /></div>
                  </div>
                  <div className="swiper-slide swiper-slide-prev" style={{width: '647.111111px', marginRight: '24px'}} role="group" aria-label="1 / 4" data-swiper-slide-index={0}> 
                    <div className="photo-item"><img src="images/carsubs/user/temp.png" alt="" /></div>
                  </div>
                  <div className="swiper-slide swiper-slide-active" style={{width: '647.111111px', marginRight: '24px'}} role="group" aria-label="2 / 4" data-swiper-slide-index={1}> 
                    <div className="photo-item"><img src="images/carsubs/user/temp.png" alt="" /></div>
                  </div>
                  <div className="swiper-slide swiper-slide-next" style={{width: '647.111111px', marginRight: '24px'}} role="group" aria-label="3 / 4" data-swiper-slide-index={2}> 
                    <div className="photo-item"><img src="images/carsubs/user/temp.png" alt="" /></div>
                  </div>
                  <div className="swiper-slide" style={{width: '647.111111px', marginRight: '24px'}} role="group" aria-label="4 / 4" data-swiper-slide-index={3}> 
                    <div className="photo-item"><img src="images/carsubs/user/temp.png" alt="" /></div>
                  </div>
                  <div className="swiper-slide swiper-slide-duplicate swiper-slide-duplicate-prev" style={{width: '647.111111px', marginRight: '24px'}} role="group" aria-label="1 / 4" data-swiper-slide-index={0}> 
                    <div className="photo-item"><img src="images/carsubs/user/temp.png" alt="" /></div>
                  </div><div className="swiper-slide swiper-slide-duplicate swiper-slide-duplicate-active" style={{width: '647.111111px', marginRight: '24px'}} role="group" aria-label="2 / 4" data-swiper-slide-index={1}> 
                    <div className="photo-item"><img src="images/carsubs/user/temp.png" alt="" /></div>
                  </div></div>
                <div className="swiper-button-prev cus-prev" tabIndex={0} role="button" aria-label="Previous slide" aria-controls="swiper-wrapper-955704ad242109edb" />
                <div className="swiper-button-next cus-next" tabIndex={0} role="button" aria-label="Next slide" aria-controls="swiper-wrapper-955704ad242109edb" />
                <div className="swiper-pagination pagi-cus" />
                <span className="swiper-notification" aria-live="assertive" aria-atomic="true" /></div>
            </div>
          </div>
        </div>
      </div> */}